module.exports = __webpack_public_path__ + "img/vetor-cadastro.dd190a58.svg";